import { useEffect, useRef, useState } from "react";
import { Menu } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const TopNav = ({ setIsSidebarOpen, setIsMobileSidebarOpen }) => {
    const username = "Abdul";
    const email = "abdulhameed16216@gmail.com";
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef();
    const isRTL = document.dir === "rtl";
    const { t } = useTranslation();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    const navigate = useNavigate();

    const handleLogout = () => {
        // Clear user data
        localStorage.removeItem("user");
        localStorage.removeItem("theme");
        localStorage.removeItem("rtl");

        // Redirect to login
        navigate("/");
    };
    const handleToggle = () => {
        if (window.innerWidth < 640) {
            setIsMobileSidebarOpen((prev) => !prev);
        } else {
            setIsSidebarOpen((prev) => !prev);
        }
    };

    return (
        <nav className="sticky top-0 bg-primary text-primaryText px-4 py-3 shadow z-30">
            <div className={`flex justify-between items-center w-full`}>
                {/* Sidebar Toggle Button */}
                <button onClick={handleToggle} className={`text-primaryText`} >
                    <Menu size={28} />
                </button>

                {/* User Info */}
                <div className="flex items-center gap-4">
                    <span className="text-sm sm:text-base font-medium">{t("welcome_user", { name: username })}</span>

                    {/* Profile Dropdown */}
                    <div className="relative" ref={dropdownRef}>
                        <button
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            className="flex items-center space-x-2 bg-gray-800 p-1 rounded-full"
                        >
                            <img className="w-8 h-8 rounded-full" src="/images/profile-image.png" alt="user" />
                        </button>

                        {dropdownOpen && (
                            <div className={`absolute  ${isRTL ? "left-0" : "right-0"} mt-2 w-48 bg-white rounded-md shadow-md z-50`}>
                                <div className="px-4 py-3">
                                    <span className="block text-sm font-medium text-gray-900">{username}</span>
                                    <span className="block text-sm text-gray-500 truncate ">{email}</span>
                                </div>
                                <ul className="py-2">
                                    <li>
                                        <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                            {t('change_password')}
                                        </a>
                                    </li>
                                    <li>
                                        <button
                                            onClick={handleLogout}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                        >
                                            {t('sign_out')}
                                        </button>

                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default TopNav;
